import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetBlobsToOrganizations = (params) =>
  axios.get(`${apiPaths.blobsToOrganizationsBase}`, { params: { ...params, paging: false } });

const onCreateBlobsToOrganizations = (params) => axios.post(apiPaths.blobsToOrganizationsBase, params);

const onDeleteBlobsToOrganizations = (blobToOrganizationIds) =>
  axios.post(`${apiPaths.blobsToOrganizationsBase}/delete-many`, blobToOrganizationIds);

export { onGetBlobsToOrganizations, onCreateBlobsToOrganizations, onDeleteBlobsToOrganizations };
